export default "__VITE_ASSET__CTQW0J8i__"